import {
  createDefaultFieldFactory,
  FieldTypes,
} from '@sitecore-jss/sitecore-jss-react-forms'
import TextField from './components/textField'
import FileUpload from './components/fileUpload'
import EmailField from './components/emailField'
import NumberField from './components/numberField'
import TelephoneField from './components/telephoneField'
import PasswordField from './components/passwordField'
import MultipleLineTextField from './components/multipleLineTextField'
import CheckboxField from './components/checkboxField/index'
import Dropdownfield from './components/dropdownfield'
import SectionFeild from './components/sectionField'
import checkBoxListField from './components/checkBoxListField'
import RadioButtonListField from './components/radioButtonListField'
import TextViewField from './components/textViewField'
import Recaptcha from './components/recaptcha'
import RichText from './components/richText/RichText'

const FieldTypesC = {
  ...FieldTypes,
  Captcha: '{AF50468E-66DE-48B7-9FA5-A9066241892B}',
  'Rich Text': '{976EC698-39C5-4522-A930-E3149267C863}',
}
const defaultFieldFactory = createDefaultFieldFactory()

defaultFieldFactory.setComponent(FieldTypesC.SingleLineText, TextField)

defaultFieldFactory.setComponent(FieldTypesC.FileUpload, FileUpload)
defaultFieldFactory.setComponent(FieldTypesC.NumberField, NumberField)
defaultFieldFactory.setComponent(FieldTypesC.Email, EmailField)
defaultFieldFactory.setComponent(FieldTypesC.Telephone, TelephoneField)
defaultFieldFactory.setComponent(FieldTypesC.Password, PasswordField)
defaultFieldFactory.setComponent(
  FieldTypesC.MultipleLineText,
  MultipleLineTextField
)
defaultFieldFactory.setComponent(FieldTypesC.Checkbox, CheckboxField)
defaultFieldFactory.setComponent(FieldTypesC.DropdownList, Dropdownfield)
defaultFieldFactory.setComponent(FieldTypesC.Section, SectionFeild)
defaultFieldFactory.setComponent(FieldTypesC.CheckboxList, checkBoxListField)
defaultFieldFactory.setComponent(
  FieldTypesC.RadioButtonList,
  RadioButtonListField
)
defaultFieldFactory.setComponent(FieldTypesC.TextField, TextViewField)
defaultFieldFactory.setComponent(
  FieldTypesC['Captcha'] as FieldTypes,
  Recaptcha
)
defaultFieldFactory.setComponent(
  FieldTypesC['Rich Text'] as FieldTypes,
  RichText
)

export default defaultFieldFactory
